// extracted by mini-css-extract-plugin
export default {"paymentSection":"m8-z","disabled":"n8-z"};